import { useScrollAnimation, useScrollAnimationMultiple } from "@/hooks/useScrollAnimation";

const services = [
  {
    icon: "ri-layout-grid-line",
    title: "Residential Layout Development",
    desc: "Residential layout with all modern amenities and green spaces in Bangalore.",
  },
  {
    icon: "ri-home-2-line",
    title: "Villa Plot Development",
    desc: "Premium Urban Infra villa plots with modern infrastructure and excellent connectivity on Sarjapur Road.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Property Consultation",
    desc: "Expert guidance on property selection, investment potential, legal due diligence, and documentation.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Site Visit Assistance",
    desc: "Free site visits with our team — we guide you through every project and help you make the right decision.",
  },
];

export default function Services() {
  const { ref: headRef, isVisible: headVisible } = useScrollAnimation();
  const { setRef, visibleItems } = useScrollAnimationMultiple(services.length);

  return (
    <section id="services" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div
          ref={headRef as (el: HTMLDivElement | null) => void}
          className={`text-center mb-12 reveal ${headVisible ? "visible" : ""}`}
        >
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#7FBF3F] bg-[#EAF5E1] px-3 py-1.5 rounded-full mb-3">
            What We Do
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Our Services
          </h2>
          <p className="text-gray-500 text-sm max-w-md mx-auto" style={{ fontFamily: "'Poppins', sans-serif" }}>
            From plot selection to possession — we handle every step of your real estate journey.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => (
            <div
              key={service.title}
              ref={setRef(i) as (el: HTMLDivElement | null) => void}
              className={`card-hover group bg-white border border-gray-100 rounded-2xl p-7 cursor-default reveal reveal-delay-${i + 1} ${visibleItems[i] ? "visible" : ""}`}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#EAF5E1] rounded-xl mb-5 group-hover:bg-[#1B2A4A] transition-colors duration-300">
                <i className={`${service.icon} text-xl text-[#7FBF3F] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="font-semibold text-base text-[#1B2A4A] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{service.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed" style={{ fontFamily: "'Poppins', sans-serif" }}>{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
